module.exports = __webpack_public_path__ + "img/serv-emp.f7f9f645.jpg";